export default __webpack_public_path__ + "static/media/LOGO-ligne.f05989a4.svg";